var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgArrowinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 1000"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M757.6 500c.3 15.5-5.5 31.2-17.3 43.1L343.5 939.8c-23.1 23.1-60.7 23.1-83.8 0-23.1-23.1-23.1-60.7 0-83.8l356-356-356-356c-23.2-23.1-23.2-60.7 0-83.8 23.1-23.1 60.7-23.1 83.8 0L740.3 457c11.9 11.8 17.7 27.4 17.3 43z"
})));

export default SvgArrowinline;